import { Intervals } from './../utils/createIntervalFromString';
import { axiosInstance } from './api'
import {createIntervalFromString} from 'utils/createIntervalFromString'
import { AdSpot } from 'types/adspot'
import { EntityPage, Paging } from 'types/paging'
import { SceneGET } from 'types/scenes'

export const adSpotsApi = {
  create(params: FormData) {
    return axiosInstance.post('publisher/ad-spots/create', params)
  },
  paging(params: Paging) {
    return axiosInstance.post<EntityPage<AdSpot>>('publisher/ad-spots/paging', params)
  },
  getOne(id: number) {
    //remove auth header
    return axiosInstance.get<AdSpot>(`publisher/ad-spots/${id}`)
  },
  publicPaging(params: Paging) {
    return axiosInstance.post<EntityPage<AdSpot>>(`ad-spots/paging`, params)
  },
  getPublicOne(id: number) {
    return axiosInstance.get<AdSpot>(`ad-spots/${id}`)
  },
  update(id: number, params: FormData) {
    return axiosInstance.put(`publisher/ad-spots/${id}`, params)
  },
  delete(id: number) {
    return axiosInstance.delete(`publisher/ad-spots/${id}`)
  },

  getScenes(id: number) {
    return axiosInstance.get<{ scenes: SceneGET[] }>(`publisher/ad-spots/${id}/scenes`)
  },
  getStats(id: number, interval: Intervals) {
    return axiosInstance.post<{ day: number; interval: number; total: number }>(
      `ad-spots/${id}/stats`,createIntervalFromString(interval)
    )
  },
  getPublicStats(id: number, interval: Intervals) {
    return axiosInstance.post<{ day: number; interval: number; total: number }>(
      `public/ad-spots/${id}/stats`, createIntervalFromString(interval)
    )
  },
  getPin(id: number) {
    return axiosInstance.get<{ pin?: number; uuid?: string }>(`publisher/ad-spots/${id}/identifier`)
  },
  getModType(id: number) {
    return axiosInstance.get<{ auto_approval: 0 | 1 }>(`publisher/ad-spots/${id}/moderation-type`)
  },
  downloadDecentralandAsset(id: number) {
    return axiosInstance.get(`/download-decentraland-asset/${id}`, { responseType: 'blob' })
  },
  downloadVoxelAsset() {
    return axiosInstance.get('download-voxels-asset', { responseType: 'blob' })
  },
  downloadUnityAsset() {
    return axiosInstance.get('download-unity-asset', { responseType: 'blob' })
  },
  downloadRobloxAsset() {
    return axiosInstance.get('download-roblox-scene-files', { responseType: 'blob' })
  },
}
